import React from "react";
import { Box } from "grommet";
import { HeaderNavigation } from "../../components/Headers/GlobalHeader"; // If you have a global header
import { StickyFooter } from "../../components/Footers/GlobalFooter"; // If you have a global footer
import { useNavigate, useParams } from "react-router-dom";
import UserCentricView from "../../components/ManagerPortal/UserCentricView";
import UsersGroupsManagement from "../../components/ManagerPortal/UsersGroupManagement";
import HeaderComponent from "../../components/ManagerPortal/HeaderComponent";
import { LinkPrevious } from "grommet-icons";

export const UserGroupsPage = () => {
  const navigate = useNavigate();
  const { manager_id } = useParams();
  return (
    <Box justify="between" fill="vertical">
      {/* Global Header */}
      <HeaderNavigation />

      <HeaderComponent current={"Users management"} previous={"Dashboard"} current_link_name={"users-groups"} previous_link_name={"dashboard"} color_modify={1} required={1}/>
      {/* Main Manager Dashboard Component */}
      <Box flex="grow" pad="medium">
        <UsersGroupsManagement />
        {/* <UserCentricView manager_id={manager_id} /> */}
      </Box>

      {/* Global Footer */}
      <StickyFooter />
    </Box>
  );
};
